import React, { useEffect, useState } from 'react';
import { Container, Typography } from '@mui/material';
import StyledBox from 'views/information-module/InsuranceView/InsuranceView.styles';
import {
  CoveringRoad,
  CoveringMotorcycle,
  CoveringOffRoad,
  CoveringRider,
} from 'views/information-module/InsuranceView/components';
import { InfoPageTitle } from 'views/common/components';
import PATHS from 'lib/navigation/paths';
import { useTranslation } from 'next-i18next';
import generateMetaData from 'lib/utils/generateMetaData';
import Head from 'next/head';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';
import axios, { API } from 'lib/config/axios';

const InsuranceView = (props) => {
  // props
  const { ssrSeoValues } = props;

  // states
  const [seoValues, setSeoValues] = useState(ssrSeoValues);

  // init
  const { t } = useTranslation('fe_er_insurance_page');
  const handleErrorResponse = useErrorsHandler();

  const mainTitleObject = {
    name: t('fe_er_insurance_page:header'),
  };
  const breadcrumbsObject = {
    links: [
      {
        text: t('fe_er_insurance_page:eagleRider'),
        path: PATHS.home(),
      },
      {
        text: t('fe_er_insurance_page:information'),
        path: PATHS.information(),
      },
      {
        text: t('fe_er_insurance_page:damage_waiver_and_insurance'),
      },
    ],
  };

  // handlers
  const getSeoValues = () => {
    axios
      .get(API.seoValues)
      .then((res) => {
        setSeoValues(res?.data);
      })
      .catch((error) => {
        handleErrorResponse(error, false);
      });
  };

  // useEffects
  useEffect(() => {
    if (ssrSeoValues) return;
    getSeoValues();
  }, []);

  return (
    <>
      {seoValues && <Head>{generateMetaData(seoValues)}</Head>}
      <StyledBox pb={7}>
        <InfoPageTitle
          mainTitleObject={mainTitleObject}
          breadcrumbsObject={breadcrumbsObject}
          buttonText={t('fe_er_insurance_page:start_reservation')}
          date={t('fe_er_insurance_page:last_revised')}
        />
        <Container maxWidth="xl">
          <Typography
            component="p"
            variant="body1"
            dangerouslySetInnerHTML={{
              __html: t('fe_er_insurance_page:page_description'),
            }}
          />
          <CoveringRoad />
          <CoveringRider />
          <CoveringMotorcycle />
          <CoveringOffRoad />
        </Container>
      </StyledBox>
    </>
  );
};

export { InsuranceView };
